import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { useStore } from '@modules';

import { RowData } from '../../useRowData';

import style from './ModalContent.scss';

const cn = bemCssModules(style, 'ModalContent');
const ti = getTestId('ModalContent');

const getTime = (lang: string | undefined, timestamp: number) =>
  new Date(timestamp).toLocaleTimeString(lang, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

export type TModalContent = {
  data: RowData;
  isFailed?: boolean;
};

const ModalContent: CustomFC<TModalContent> = props => {
  const { className, children, data, isFailed } = props;

  const { t } = useTranslation();
  const { status, timestamp, crypto, fiat, info } = data;

  const [{ global }] = useStore();
  const { lang } = global;

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <div className={cn('content', { isFailed })}>
        <div className={cn('status')}>{t(`transactions.${status}`)}</div>
        <div className={cn('date', { isFailed }, ['small'])}>{getTime(lang, timestamp)}</div>
        <div className={cn('crypto')}>{crypto}</div>
        {fiat && <div className={cn('fiat')}>{fiat}</div>}
        <div className={cn('info')}>{info}</div>
      </div>
      {children}
    </div>
  );
};

export default ModalContent;
